import { render, staticRenderFns } from "./addStadium.vue?vue&type=template&id=6ff6f040&scoped=true"
import script from "./addStadium.vue?vue&type=script&lang=js"
export * from "./addStadium.vue?vue&type=script&lang=js"
import style0 from "./addStadium.vue?vue&type=style&index=0&id=6ff6f040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6f040",
  null
  
)

export default component.exports